import type { ReactNode } from "react";

import type { SafeHtmlAttributes } from "@core/types/SafeHtmlAttributes";
import classnames from "classnames";

import { MenuHeader } from "./components/MenuHeader";

import styles from "./Menu.module.scss";

export type MenuProps = {
  title?: string;
  onClose?: () => void;
  closeButtonLabel?: string;
  children: ReactNode;
  className?: string;
} & SafeHtmlAttributes<HTMLDivElement>;

export const Menu = ({ title, onClose, closeButtonLabel, children, className, ...rest }: MenuProps) => (
  <div className={classnames(styles.menu, className)} {...rest}>
    {title && <MenuHeader title={title} onClose={onClose} closeButtonLabel={closeButtonLabel} />}
    <div role="menu" className={styles.content}>
      {children}
    </div>
  </div>
);
